import { useQuery } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { queryKeys } from '../react-query.config';

interface FeedFixture {
  externalId: string;
  leagueId: string;
  homeTeamId: string;
  awayTeamId: string;
  scheduledDate: string;
  status: 'scheduled' | 'live' | 'finished' | 'postponed' | 'cancelled';
  venue?: string;
  homeScore?: number;
  awayScore?: number;
}

interface FeedFixturesResponse {
  fixtures: FeedFixture[];
}

export type { FeedFixture };

export const getFeedFixtures = async (
  leagueId: string,
  date?: string,
  from?: string,
  to?: string
): Promise<FeedFixture[]> => {
  const params: Record<string, string> = { leagueId };
  if (from && to) {
    params.startDate = from;
    params.endDate = to;
  } else if (date) {
    params.startDate = date;
    params.endDate = date;
  }

  const response = (await api.get('/feed/fixtures', {
    params,
  })) as FeedFixturesResponse;
  return response.fixtures || [];
};

export const useGetFeedFixturesQuery = (
  leagueId: string | undefined,
  date?: string,
  from?: string,
  to?: string
) => {
  return useQuery({
    queryKey: queryKeys.feed.fixtures(leagueId || '', date, from, to),
    queryFn: () => {
      if (!leagueId) throw new Error('League ID is required');
      return getFeedFixtures(leagueId, date, from, to);
    },
    enabled: !!leagueId,
    staleTime: 1 * 60 * 1000, // 1 minute - fixtures can change frequently
  });
};
